export const landbotHeight = 160;
export const groundHeight = 20;
export const supportBarHeight = 350;